import React from 'react';
import PropTypes from 'prop-types';

import {black500} from "assets/jss/main";

CustomerName.propTypes = {
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
};

function CustomerName({firstName, lastName, ...props}) {
    return (
        <div style={{ color: black500 }}>
            <span>{lastName}</span>
            <br/>
            <span>{firstName}</span>
        </div>
    );
}

export default CustomerName;
